export default "__VITE_ASSET__fad7c20e__"